module.exports = __webpack_public_path__ + "static/image5-1ead3bb2385f5646a60a1e6bf032dd24.png";